<footer class="bg-secondary">
  <div class="py-6 container flex flex-wrap gap-6 md:gap-28">
    <div class="text-primary">
      <h3 class="text-lg font-medium">{{ 'footer.aboutUs.title' | transloco }}</h3>
      <ul class="mt-4 text-sm">
        <li>
          <a routerLink="/about-us"
             class="transition-colors duration-300 hover:text-corporate-400">{{ 'footer.aboutUs.aboutUs' | transloco }}</a>
        </li>
      </ul>
    </div>
    <div class="text-primary">
      <h3 class="text-lg font-medium">{{ 'footer.support.title' | transloco }}</h3>
      <ul class="mt-4 text-sm">
        <li>
          <a href="mailto:stalcraftprojects@gmail.com"
             class="transition-colors duration-300 hover:text-corporate-400">{{ 'footer.support.contactUs' | transloco }}</a>
        </li>
        <li class="mt-2">
          <a routerLink="/faq"
             class="transition-colors duration-300 hover:text-corporate-400">{{ 'footer.support.faq' | transloco }}</a>
        </li>
      </ul>
    </div>
    <div class="text-primary">
      <h3 class="text-lg font-medium">{{ 'footer.legal.title' | transloco }}</h3>
      <ul class="mt-4 text-sm">
        <li>
          <a routerLink="legal/user-agreement"
             target="_blank"
             class="transition-colors duration-300 hover:text-corporate-400">{{ 'footer.legal.userAgreement' | transloco }}</a>
        </li>
        <li class="mt-2">
          <a routerLink="legal/privacy-policy"
             target="_blank"
             class="transition-colors duration-300 hover:text-corporate-400">{{ 'footer.legal.privacyPolicy' | transloco }}</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="bg-tertiary text-primary text-sm">
    <div class="flex justify-center items-center py-4 container">
      {{ 'footer.copyright' | transloco }}
    </div>
  </div>
</footer>
